var nameIdMap = {};

var createAutoName = function createAutoName(prefix) {
  var nextId = nameIdMap[prefix];

  if (!nextId) {
    nextId = 1;
  }

  nameIdMap[prefix] = nextId + 1;
  return "".concat(prefix).concat(nextId);
};

export { createAutoName };
